import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import holidaysData from '../../data/events/holidaysData';
import pageIntros from '../../cms/page-intros.json';
import PageChrome from '../../components/layout/PageChrome';
import HolidayModal from '../../components/ui/HolidayModal';
import '../../css/events/Holidays.css';

const intro = pageIntros.holidays || {};

const Holidays = () => {
  const [selectedHoliday, setSelectedHoliday] = useState(null);
  const navigate = useNavigate();
  const { holidayId } = useParams();

  useEffect(() => {
    if (holidayId) {
      const holiday = holidaysData.find(h => h.id === holidayId);
      if (holiday) {
        setSelectedHoliday(holiday);
      } else {
        navigate('/holidays');
      }
    } else {
      setSelectedHoliday(null);
    }
  }, [holidayId, navigate]);

  const closeModal = () => {
    navigate('/holidays');
  };

  // renderSchedule function moved to utils/holidayUtils.js

  return (
    <>
      <PageChrome
        title={intro.title}
        subtitle={intro.subtitle}
        intro={intro.intro}
      >
        <section className="holidays-section">
          <div className="holidays-grid">
            {holidaysData.map((holiday, index) => (
              <div 
                key={holiday.id}
                className="holiday-card"
                onClick={() => navigate(`/holidays/${holiday.id}`)}
                style={{ '--holiday-bg-color': holiday.backgroundColor }}
              >
                <div className="holiday-icon">{holiday.icon}</div>
                <h3 className="holiday-name">{holiday.name}</h3>
                <p className="holiday-description">{holiday.description}</p>
                {!holiday.scheduleReady && (
                  <div className="schedule-status">
                    <span className="status-badge">Schedule TBD</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>
      </PageChrome>

      {/* Holiday Modal */}
      <HolidayModal holiday={selectedHoliday} onClose={closeModal} />
    </>
  );
};

export default Holidays; 